<template>
  <div ref="mapDialog">
    <div class="detail" ref="detail" v-if="showDialog">
      <p v-if="info.workerName">人员姓名: {{info.workerName || '--'}}</p>
      <p v-if="info.teamName">班组名称: {{info.teamName || '--'}}</p>
      <p>签到: {{info.type}}</p>
      <p v-if="info.teamName">签到人数: {{info.num || 0}}人</p>
      <p v-if="info.time">时间: {{info.time ? info.time.slice(11) : '--'}}</p>
      <el-image
        v-if="info.image"
        :src="info.image"
        :preview-src-list="[info.image] | imgListFormat"
        fit="fill">
      </el-image>
    </div>


    <div class="popup" v-if="showPerson" ref="popup" :class="{ gray: info.deviceStatus !== '1' }">
      <div class="header">
        <p>{{info.workerName || (info.teamName + '【' + info.deviceNumber.substring(info.deviceNumber.length -4 , info.deviceNumber.length) + '】') || '--'}}</p>
        <p class="state" v-show="info.deviceStatus === '2'" :class="info.deviceStatus === '1' ? 'normal' : 'offline' ">{{info.deviceStatus === '1' ? '在线' : '离线' }}</p>
        <p class="state" v-show="info.deviceStatus === '1' && info.dutyStatus && ['1', '2'].includes(info.dutyStatus)" :class="['normal', 'alarm'][+info.dutyStatus - 1]  ">{{dutyStatus[info.dutyStatus - 1 ]}}</p>
        <p class="state alarm" v-show="info.sosStatus && info.sosStatus === '1'">SOS</p>
      </div>
      <div class="content">
        <div class='list' v-show="info.deviceType && info.deviceType === 'D0'">
          <div v-for="(item,index) in health" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="value">{{ info[item.value] || '--' }}</p>
              <p class="state" v-if="item.value !== '--'" :class="(item.status === '正常' || item.status === '--') ? 'normal' : 'alarm'">{{ item.status }}</p>
            </div>
          </div>
        </div>

        <div style="display: flex; justify-content: center">
          <el-button type="primary" @click="onPlay">轨迹查看</el-button>
        </div>
      </div>
    </div>

    <playBack :showDialog.sync="showPlayBack" :worker="info" @closeDialog="closeDialog"></playBack>
  </div>
</template>

<script>
import { px2vw } from '@/utils/util'
import {getMapIcon} from '@/views/device/mapIcon'
import playBack from '@/views/person/playback.vue'
export default {
  name: 'DeviceMap',
  components: {
    playBack
  },
  data () {
    return {
      marker: [],
      info: {},
      showDialog: false,
      showPlayBack: false,
      showPerson: false,
      health:[
        {
          name: '收缩压(mmHg)',
          value: 'highpressure',
          icon: 'icon-xieya',
          status: ''
        },
        {
          name: '舒张压(mmHg)',
          value: 'lowpressure',
          icon: 'icon-xieya',
          status: ''
        },
        {
          name: '心率(次/min)',
          value: 'rate',
          icon: 'icon-xinshuai',
          status: ''
        }
      ],
      dutyStatus: ['在岗', '脱岗', '--'],
      objectId: ''
    }
  },
  filters: {
    imgListFormat (list) {
      return list || []
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    }
  },
  watch: {
    '$route' () {
      this.clearOverlayer()
    },
    projectId () {
      this.clearOverlayer()
    }
  },
  created () {
    // 地图签到统计
    this.$event.$on('getMapCheckInList', (info) => {
      if (!this._map) {
        this._map = this.$parent.$children[0]._map
      }
      this.clearOverlayer()
      if (info && info.signNum && info.signNum > 0) {
        this.load(info)
      }
    })

    this.$event.$on('drawDevice', res => {
      if (!this._map) {
        this._map = this.$parent.$children[0]._map
      }
      res.forEach(item => item.longitude && this.renderMarker(item, [item.longitude, item.latitude], this._map))
      this.$parent.$children[0].setFitMarkers()
    })
  },
  destroyed () {
    this.clearOverlayer()
    this.$event.$off('getMapCheckInList')
    this.$event.$off('drawDevice')
  },
  methods: {
    // 同步获取班组和工人打卡信息
    async load (item) {
      const info = { projectId: this.projectId, attendanceDate: item.day }
      const data = await this.$axios.get(this.$apis.person.selecSingleAttendanceList, info)
      const data1 = await this.$axios.get(this.$apis.person.selecTeamAttendanceList, info)
      this.addCadMarkers([...data, ...data1])
    },
    removeMarker () {
      if (this.marker.length > 0) {
        this.marker.forEach(item => item.remove())
      }
      this.marker = []
    },
    clearOverlayer () {
      this.removeMarker()
      this.showDialog = false
      this.showPerson = false
      this._popup && this._popup.remove()
    },
    addCadMarkers (device) {
      if (device.length > 0) {
        this.addCadMarker(this._map, device)
      } else {
        this._map.setCenter(this.$parent.mapCenter)
        this._map.setZoom(15)
      }
    },
    // 劳务考勤上下班
    addCadMarker (map, list) {
      list.forEach(item => {
        const types = ['on', 'off']
        types.forEach(item1 => item[item1 + 'Longitude'] && this.renderMarker({
          type: item1 === 'on' ? '上班' : '下班',
          workerName: item.workerName,
          teamName: item.teamName,
          time: item[item1 + 'SignTime'],
          num: item[item1 + 'SignNum'],
          image: item[item1 + 'SignImage']
        }, [item[item1 + 'Longitude'], item[item1 + 'Latitude']], map))
      })
      this.$parent.$children[0].setFitMarkers()
    },
    renderMarker (item, position, map) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url('${this.getIcon(item)}')`
      el.style.width = px2vw(36) + 'px'
      el.style.height = px2vw(48) + 'px'
      el.style.backgroundSize = '100%'
      const el1 = document.createElement('div')
      const deviceNumber = item.deviceNumber ? '【' + item.deviceNumber.substring(item.deviceNumber.length - 4, item.deviceNumber.length) + '】' : ''
      el1.innerText = item.type ? `【${item.type}】` + (item.workerName || item.teamName) : (
        item.teamName && item.teamName.length > 6 ? item.teamName.substring(0, 6) + '...' + deviceNumber : (item.teamName ? item.teamName + deviceNumber : item.workerName)
      )
      el1.style.position = 'absolute'
      el1.style.top = -px2vw(20) + 'px'
      el1.style.left = '50%'
      el1.style.transform = 'translateX(-50%)'
      el1.style.textAlign = 'center'
      el1.style.background = '#ffffff'
      el1.style.overflow = 'hidden'
      el1.style.whiteSpace = 'nowrap'
      el1.style.textOverflow = 'ellipsis'
      el1.style.maxWidth = px2vw(200) + 'px'
      el.appendChild(el1)
      this.drawMarker(el, position, map, item)
    },
    getIcon (data) {
      if (data.type) {
        return require('../../assets/img/mapIcon/device_1006_1.svg')
      } else {
        return getMapIcon('1006', data)
      }
    },
    drawMarker (el, co, map, item) {
      const marker = new vjmap.Marker({
        element: el,
        anchor: 'bottom'
      })
      marker.setLngLat(co).addTo(map)
      el.addEventListener('click', (e) => {
        this.info = item
        if (item.type) {
          this.showDialog = true
        } else {
          this.showPerson = true
        }
        this.$nextTick(() => {
          const el = item.type ? this.$refs.detail : this.$refs.popup
          marker.setPopup(new vjmap.Popup({
            closeOnClick: true,
            closeButton: false,
            anchor: 'bottom',
            offset: [0, -px2vw(48)]
          }).setDOMContent(el))
        })
      })
      this.marker.push(marker)
    },
    onPlay () {
      this.showPlayBack = true
    },
    closeDialog () {
      this.showPlayBack = false
    }
  }
}
</script>
<style scoped lang='scss'>
.popup{
  width: 400px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  background: var(--right-bg-color);
  border-radius: 10px;
  padding-bottom: 20px;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    padding: 10px 19px;
    color: #FFFFFF;
    border-radius: 10px 10px 0 0;
  }
  .content{
    color: var(--header-bar-title-color);
    padding: 16px 0 0 19px;
  }
 }

 .detail{
  width: 164px;
  background: #FFFFFF;
  box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
  border-radius: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
  padding: 12px;
  p{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 9px;
    }
 }

 .el-image{
  width: 140px;
  height: 100px;
  margin-top: 4px;
 }

 .popup{
  &.gray{
  .icon{
    background: #B7B7B7 !important;
    border: 2px solid #B7B7B7 !important;
  }
  .setting{
    color: #B7B7B7 !important;
  }
}
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    border-radius: 10px 10px 0px 0px;
    padding: 10px 19px;
    color: #FFFFFF;
    p:nth-of-type(1){
      width: 260px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .state{
    margin-left: 2px;
    // color: #03FF21;
    &.offline{
      color: #E6E6E6;
      //
    }
    &.alarm{
      //
      color: #E51212;
    }
    &.normal{
      //
      color: #03FF21;
    }
  }
  .content{
    color: var(--header-bar-title-color);
    // background: var(--right-bg-color);
    margin: 20px 0 -8px;
    padding-bottom: 20px;
    font-size: 12px;
    .video {
      width: 360px;
      height: 180px;
      border-radius: 4px;
      margin-top: -16px;
    }
    .item{
      position: relative;
      padding-left: 13px;
      margin-bottom: 19px;
      .setting{
        position: absolute;
        right: 0;
        top: 3px;
        cursor: pointer;
        color: #42A5F5;
      }
      &::after{
        position: absolute;
        content: '';
        left: 0px;
        top: calc(50% - 2px);
        width: 4px;
        height: 4px;
        background: var(--header-bar-title-color);
        border-radius: 2px;
      }
    }
    .list{
      // display: flex;
      // flex-wrap: wrap;
      display: grid;
      grid-template-columns: 126px 129px 100px;
      &.padding20{
        margin-top: 21px;
      }
      >div{
        display: flex;
        flex: 0 0 calc((100%)/3);
        font-size: 12px;
        margin-bottom: 28px;
        .icon{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          width: 30px;
          height: 30px;
          background: #42A5F5;
          border-radius: 50%;
          border: 2px solid #D8EEFF;
          margin-right: 9px;
          i {
            color: #ffffff;
          }
        }
        .status {
          &.alarm{
            color: #FF3F29;
          }
          &.normal{
            color: #52C41A;
          }
        }
        &:last-child, &:nth-of-type(12), &:nth-of-type(11){
          .name{
            white-space: nowrap;
          }
        }
        &:nth-of-type(12){
          grid-column: 1 / 2;
        }
      }
    }
  }
  .time{
    height: 30px;
    line-height: 30px;
    background: #EAEEF5;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    font-size: 12px;
  }

  .tabs{
    display: flex;
    width: 360px;
    height: 27px;
    background: #3277F3;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    overflow: hidden;
    padding-left: 6px;
    padding-top: 2px;
    >div{
      display: flex;
      justify-content: center;
      align-content: center;
      width: 66px;
      cursor: pointer;
      line-height: 24px;
      &.active{
        width: 66px;
        // height: 26px;
        // background: #F5F5F5;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        border-bottom: 66px solid #F5F5F5;
        border-right: 10px solid transparent;
      }
    }
  }
  ::v-deep {
    .el-date-editor{
      width: 294px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #C3C3C3;
      margin: 20px 33px;
    }
    .el-table th.gutter{
      display: none;
      width:0
    }
    .el-table colgroup col[name='gutter']{
      display: none;
      width: 0;
    }
  }
 }
</style>
